(function () {
  'use strict';
  if (window.ETTLeadTracking) return;

  var destination = 'AW-11466593652/9yD0CJ3j3_scEPSq2dsq';
  var pending = {};
  var sent = {};
  var pixelPending = {};
  var pixelSent = {};
  var pixelRetry;
  var pixelAttempts = 0;
  var prefix = 'ett:lead:pending:';

  function allowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(privacy && privacy.analyticsProcessingAllowed() && privacy.marketingAllowed());
    } catch (error) { return false; }
  }

  function identifier() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  function flush() {
    if (!allowed()) return;
    flushPixel();
    if (typeof window.gtag !== 'function') return;
    Object.keys(pending).forEach(function (id) {
      if (sent[id]) return;
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'ett_lead_submitted', form_type: pending[id] });
        window.gtag('event', 'conversion', {
          send_to: destination,
          transaction_id: id
        });
        sent[id] = true;
        delete pending[id];
      } catch (error) { /* Measurement must not affect inquiry delivery. */ }
    });
  }

  // Publish only the accepted inquiry signal. Shopify's existing Meta app
  // continues to own all ecommerce events; no customer form values are sent.
  function flushPixel() {
    if (!allowed()) return;
    Object.keys(pixelPending).forEach(function (id) {
      if (pixelSent[id]) return;
      try {
        var analytics = window.Shopify && window.Shopify.analytics;
        if (!analytics || typeof analytics.publish !== 'function') return;
        var result = analytics.publish('ett:lead_submitted', {
          event_id: id, form_type: pixelPending[id]
        });
        if (result === false) return;
        pixelSent[id] = true;
        delete pixelPending[id];
      } catch (error) { /* Unavailable analytics cannot affect the inquiry. */ }
    });
    // The customer-events API may finish loading after the form succeeds.
    if (Object.keys(pixelPending).length && !pixelRetry && pixelAttempts < 30) {
      pixelAttempts += 1;
      pixelRetry = window.setTimeout(function () {
        pixelRetry = null;
        flushPixel();
      }, 2000);
    }
  }

  function record(form, type) {
    try {
      var id = form.__ettLeadId || (form.__ettLeadId = identifier());
      if (!sent[id]) pending[id] = type === 'journey' || type === 'agency' ? type : 'contact';
      if (!pixelSent[id]) pixelPending[id] = type === 'journey' || type === 'agency' ? type : 'contact';
      pixelAttempts = 0;
      flush();
    } catch (error) { /* Keep the successful submission visible. */ }
  }

  window.ETTLeadTracking = { record: record };
  document.addEventListener('visitorConsentCollected', flush);
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) flush();
    });
  }

  // Native Shopify contact forms navigate; require both a prior submission
  // and Shopify's server-rendered success marker. Refresh alone is not a lead.
  function bindNativeForms() {
    document.querySelectorAll('form[data-ett-lead-form]').forEach(function (form) {
      if (form.closest('[data-agency-inquiry]')) return;
      var key = prefix + form.getAttribute('id');
      form.addEventListener('submit', function (event) {
        if (event.defaultPrevented || !form.checkValidity() || !allowed()) return;
        try {
          sessionStorage.setItem(key, JSON.stringify({ id: identifier(), time: Date.now() }));
        } catch (error) { /* A blocked store must not block the form. */ }
      });
    });
    document.querySelectorAll('[data-ett-lead-success]').forEach(function (marker) {
      var key = prefix + marker.getAttribute('data-ett-lead-success');
      try {
        var previous = JSON.parse(sessionStorage.getItem(key) || 'null');
        sessionStorage.removeItem(key);
        if (!previous || !previous.id || Date.now() - previous.time > 1800000) return;
        marker.__ettLeadId = previous.id;
        record(marker);
      } catch (error) { /* Missing or invalid pending state is not a conversion. */ }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindNativeForms);
  } else {
    bindNativeForms();
  }
})();
